import { bg } from './bg';
import { CURRENCY_SYMBOLS } from './currencies';
import { en, Translations } from './en';

export interface Language {
   /** ISO 639-1, what `Intl.Locale(...).language` and `<html lang>` use. */
   code: string;
   /** The language's own name for itself, so a reader can find it whatever is showing. */
   name: string;
   messages: Translations;
}

/**
 * The languages the UI is offered in, in picker order: Bulgarian (the shops
 * Oopsy serves) and English (for everyone else). More come with a paying shop
 * in their market; earlier translations into es, de, fr, it, ro and el are in
 * git history (before feat/ai-query-understanding).
 *
 * Adding one: a file typed `Translations` (the compiler lists any missing key),
 * an entry here, and nothing else — auto-selection derives from the country.
 */
export const LANGUAGES: Language[] = [
   { code: 'bg', name: 'Български', messages: bg },
   { code: 'en', name: 'English', messages: en },
];

/** Shown when nothing better is known: the most widely read of the set. */
export const FALLBACK_LANGUAGE = 'en';

/** Overrides of the shared currency symbols, per language. */
const CURRENCY_OVERRIDES: Record<string, Record<string, string>> = {
   bg: { BGN: 'лв.' },
};

/** Everything ngx-translate is given for one language: its texts plus currency symbols. */
export function dictionaryFor(language: Language): Record<string, string> {
   return { ...CURRENCY_SYMBOLS, ...CURRENCY_OVERRIDES[language.code], ...language.messages };
}

export function isSupportedLanguage(code: unknown): code is string {
   return typeof code === 'string' && LANGUAGES.some((language) => language.code === code);
}
